import { jsx as _jsx } from "react/jsx-runtime";
import { kareoLinkAppointmentKinds, unopenableAppointmentKinds } from 'constants/appointmentKind';
import { kareoNoteStatusLabels, nonFormNoteSchemas, } from 'constants/note-schemas';
import { notAvailable } from 'constants/strings';
import { useMe } from 'shared/hooks';
import { OpenKareoNoteStatus, WrittenInKareoStatus } from '../components';
import { useIsBeforeCompassOnboardDateAndMine } from './useIsBeforeCompassOnboardDateAndMine';
var SortableNoteStatuses;
(function (SortableNoteStatuses) {
    SortableNoteStatuses[SortableNoteStatuses["signed"] = 0] = "signed";
    SortableNoteStatuses[SortableNoteStatuses["draft"] = 1] = "draft";
    SortableNoteStatuses[SortableNoteStatuses["notStarted"] = 2] = "notStarted";
    SortableNoteStatuses[SortableNoteStatuses["writtenInKareo"] = 3] = "writtenInKareo";
    SortableNoteStatuses[SortableNoteStatuses["overdue"] = 4] = "overdue";
})(SortableNoteStatuses || (SortableNoteStatuses = {}));
export var useTableNoteStatus = function () {
    var userDetails = useMe().data;
    var isBeforeCompassOnboardDateAndMine = useIsBeforeCompassOnboardDateAndMine();
    var getStatusText = function (note, appointment, date, overdue) {
        var _a, _b;
        var isLegacyImport = (note === null || note === void 0 ? void 0 : note.noteSchema) === nonFormNoteSchemas.legacyImport;
        if (isLegacyImport) {
            return kareoNoteStatusLabels[note.sessionInfo.status];
        }
        if (appointment) {
            // If notes are taken on kareo for this appointment kind and user is a caregiver, show kareo link
            if (isBeforeCompassOnboardDateAndMine(date, (_b = (_a = appointment.care_provider) === null || _a === void 0 ? void 0 : _a.userId) !== null && _b !== void 0 ? _b : '')) {
                return _jsx(WrittenInKareoStatus, {});
            }
            else if (kareoLinkAppointmentKinds.includes(appointment.kind) &&
                (userDetails === null || userDetails === void 0 ? void 0 : userDetails.care_provider)) {
                return _jsx(OpenKareoNoteStatus, {});
            }
            else if (unopenableAppointmentKinds.includes(appointment.kind)) {
                return notAvailable;
            }
        }
        if (overdue && (note === null || note === void 0 ? void 0 : note.ownerId) === (userDetails === null || userDetails === void 0 ? void 0 : userDetails.id))
            return 'Overdue';
        return (note === null || note === void 0 ? void 0 : note.signedAt) ? 'Signed' : (note === null || note === void 0 ? void 0 : note.updatedAt) ? 'Draft' : 'Not started';
    };
    var calculateNoteStatus = function (originalRow) {
        var _a, _b, _c, _d, _e;
        if ((_a = originalRow.note) === null || _a === void 0 ? void 0 : _a.signedAt)
            return SortableNoteStatuses.signed;
        if (originalRow.overdue && ((_b = originalRow.note) === null || _b === void 0 ? void 0 : _b.ownerId) === (userDetails === null || userDetails === void 0 ? void 0 : userDetails.id))
            return SortableNoteStatuses.overdue;
        if (originalRow.note)
            return SortableNoteStatuses.draft;
        if (isBeforeCompassOnboardDateAndMine(originalRow.date, (_e = (_d = (_c = originalRow.appointment) === null || _c === void 0 ? void 0 : _c.care_provider) === null || _d === void 0 ? void 0 : _d.userId) !== null && _e !== void 0 ? _e : ''))
            return SortableNoteStatuses.writtenInKareo;
        return SortableNoteStatuses.notStarted;
    };
    return { getStatusText: getStatusText, calculateNoteStatus: calculateNoteStatus };
};
